import Box from '@mui/material/Box';

import { EMPTY_STRING } from '@e-socna/empty';
import { getFragmentData, graphql } from '@e-socna/data-layer';
import { normalizeOrganizationIdentifierValue } from '@e-socna/third-parties';
import type { FragmentType } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { JSONPretty } from '../../components/JSONPretty';

import { useOrganizationSearchQuery } from '../OrganizationSearch/hooks/useOrganizationSearchQuery.hook';

export const OrganizationPage_Directory_Organization_Fragment = graphql(`
  fragment OrganizationPage_Directory_Organization_Fragment on Organization {
    _id
    identifier {
      value
    }
  }
`);

interface Props {
  readonly organization: FragmentType<
    typeof OrganizationPage_Directory_Organization_Fragment
  >;
}

export const Directory = ({ organization: pOrganization }: Readonly<Props>) => {
  const organization = getFragmentData(
    OrganizationPage_Directory_Organization_Fragment,
    pOrganization,
  );

  const identifierValue = organization.identifier?.value
    ? normalizeOrganizationIdentifierValue(organization.identifier.value)
    : EMPTY_STRING;

  const { data, isFetching, isSuccess } = useOrganizationSearchQuery({
    query: identifierValue,
  });

  if (!identifierValue) {
    return <NoData />;
  }

  if (isFetching) {
    return <Loading />;
  }

  const result = isSuccess ? data.results[0] : undefined;

  if (!result) {
    return <NoData />;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <JSONPretty
        data={result}
        id={`organization-directory-${organization._id}`}
      />
    </Box>
  );
};
